import React from "react";

const FeedGray = ({ color = "#ACACAC", height = 24, width = 24 }) => {
  return (
    <svg
    width={width + ""}
    height={height + ""}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6667 15V9C18.6667 6.17157 18.6667 4.75736 17.788 3.87868C16.9093 3 15.4951 3 12.6667 3H8.66675C5.83832 3 4.42411 3 3.54543 3.87868C2.66675 4.75736 2.66675 6.17157 2.66675 9V15C2.66675 17.8284 2.66675 19.2426 3.54543 20.1213C4.42411 21 5.83832 21 8.66675 21H20.6667"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66675 8H14.6667"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66675 12H14.6667"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66675 16H10.6667"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.6667 8H19.6667C21.0809 8 21.788 8 22.2274 8.43934C22.6667 8.87868 22.6667 9.58579 22.6667 11V19C22.6667 20.1046 21.7713 21 20.6667 21C19.5621 21 18.6667 20.1046 18.6667 19V8Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default FeedGray;
